import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EmployeeInfo } from 'services/application/application.service';
import { ScreenSizeService } from 'services/screensize/screensize.service';
import { BaseDialogOptions } from '../dialogoptions';

@Component({
    selector: 'dialog-nomineeinput-component',
    styleUrls: ['nomineeinput.dialogcomponent.scss'],
    templateUrl: 'nomineeinput.dialogcomponent.html',
})

export class NomineeInputDialogComponent implements OnInit, OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();

    title: string;
    message: string;
    oktext: string;
    canceltext: string;
    AllHeaders: string[] = [];
    ConfirmationIsUp: boolean;
    ForcedLocationNumber: string;
    PersonType: string;
    GradeLevel: string;
    NoData: boolean;
    ResultsData: MatTableDataSource<EmployeeInfo>;
    NomineeForm: FormGroup;
    SmallDisplay: boolean;
    UserSearchConducted: boolean;
    SearchResults: EmployeeInfo[];
    VisibleColumns: string[];
    VisibleHeaders: string[];
    showIcon: boolean;
    iconcolor: string;
    iconname: string;

    constructor(
        private dialogRef: MatDialogRef<NomineeInputDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: BaseDialogOptions,
        private fb: FormBuilder,
        private screenSizeSvc: ScreenSizeService
    ) { }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;

        self.title = self.data.TitleText;
        self.message = self.data.MessageText;
        self.oktext = self.data.OKText;
        self.canceltext = self.data.CancelText;

        // Watch for screen size updates
        self.screenSizeSvc.ScreenSizeSub.pipe(takeUntil(self._subrelease)).subscribe(size => {
            self.SmallDisplay = size.IsSmallSize;
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });

        // First time size initialization
        self.SmallDisplay = self.screenSizeSvc.ScreenSize.IsSmallSize;

        this.NomineeForm = this.fb.group({
            FirstName: [null, [Validators.required, Validators.maxLength(50)]],
            LastName: [null, [Validators.required, Validators.maxLength(50)]],
            Email: [null, [Validators.required, Validators.maxLength(100)]],
        });
    }

    Submit(form: FormGroup) {
        if (form.invalid) {
            return;
        }

        this.dialogRef.close(form.value);
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

}